<header class="masterview-header">
	<div class="header-wrapper d-flex">
		<div class="header-group left d-flex flex-grow-1">
			<div *ngIf="parent.showSideBar" class="header-group-item ml-2">
				<div class="d-flex h-100 align-items-center">
					<a class="sidebar-collapse btn btn-large btn-floating waves-effect waves-light" (click)="parent.toggleSidebar()">
						<i class="mdi-navigation-menu"></i>
					</a>
				</div>
			</div>
			<div class="header-group-item d-none d-sm-block">
				<div class="d-flex h-100 align-items-center">
					<a href="/" class="d-block">
						<img class="logo" [src]="parent.logoSrc" [alt]="parent.logoAlt"
							onerror="this.style['line-height']='inherit'">
					</a>
				</div>
			</div>
			<!-- client only -->
			<div *ngIf="parent.isClient && parent.hasGlobalMessage()" class="header-group-item ml-2 d-flex flex-grow-1 justify-content-center align-items-center">
				<div *ngIf="parent.hasGlobalImportantMessage()" class="warning-message">
					<div class="card red lighten-1 cursor-pointer" (click)="parent.openLink()">
						<div class="card-content white-text mt-1 mb-1 ml-2 mr-2">
							MODIFICĂRI FISCALE DIN 01.01.2023 - CITEȘTE AICI MAI MULT!
						</div>
					</div>
				</div>
				<div *ngIf="!parent.hasGlobalImportantMessage() && parent.hasGlobalWarningMessage()" class="warning-message">
					<span>{{parent.authService.globalWarningMessage}}</span>
				</div>
			</div>
			<!-- expert only -->
			<div *ngIf="(parent.isAccExpert || parent.isHRExpert) && parent.hasOnrcRecordStatusMessage()" class="header-group-item ml-2 d-flex flex-grow-1 justify-content-center align-items-center">
				<div class="warning-message">
					<span>{{ parent.authService.onrcRecordStatusMessage }}</span>
				</div>
			</div>
		</div>
		<!-- company section: fiscalNumber - companyName -->
		<div class="header-group right hide-on-med-and-down flex-shrink-0">
			<div #companyAnchor *ngIf="parent.showSideBar && parent.authService.isLoggedIn && !parent.isSubcontractor"
				class="header-group-action cursor-pointer"
				(mouseenter)="showCompanyList()" (mouseleave)="hideCompanyList()" (click)="toggleCompanyList()">
				<div class="d-flex h-100 align-items-center px-3">
					<span>{{parent.authService.user.selectedCompany.fiscalNumber}} - {{parent.authService.user.selectedCompany.companyName}}</span>
					<i class="mdi-navigation-arrow-drop-down" style="display: inline; margin-top: -3px;"></i>
				</div>
				<kendo-popup *ngIf="isCompanyListVisible"
					[anchor]="{ nativeElement: companyAnchor }"
					[popupAlign]="companyPopupAlign"
					[anchorAlign]="companyAnchorAlign"
					[animate]="false"
					(mouseenter)="cancelHideCompanyList()" (mouseleave)="hideCompanyListFromPopup()">
					<header-company-list
						[companies]="companies"
						[showFilter]="showFilter"
						(companySelect)="onCompanySelect($event)">
					</header-company-list>
				</kendo-popup>
			</div>

			<!-- OLD: dropdown-button company selection -->
			<!-- <div *ngIf="parent.showSideBar && parent.authService.isLoggedIn && !parent.isSubcontractor" class="header-group-action ml-2">
				<div class="d-flex h-100 align-items-center">
					{{parent.authService.user.selectedCompany.fiscalNumber}}
				</div>
			</div>
			<div *ngIf="parent.showSideBar && parent.authService.isLoggedIn && !parent.isSubcontractor" class="header-group-action divider-line">
				<div class="d-flex h-100 align-items-center">&nbsp;-&nbsp;</div>
			</div>
			<div *ngIf="parent.showSideBar && parent.authService.isLoggedIn && !parent.isSubcontractor" class="header-group-action">
				<div class="d-flex h-100 align-items-center">
					<dropdown-button #clientsMenu id="clientsMenu"
						class="waves-effect waves-block waves-light header-notifications h-100 pl-1 pr-3" list-class="header-clients"
						(onshow)="onShowCompaniesMenu()" (onhide)="onHideCompaniesMenu()">
						{{parent.authService.user.selectedCompany.companyName}}
						<i class="mdi-navigation-arrow-drop-down"></i>
						<dropdown-button-item *ngIf="showFilter">
							<input #filterInput type="text" class="my-2 w-100" [(ngModel)]="companiesFilter" (click)="onInputClick($event)"
								(touchstart)="onInputClick($event)" (keydown)="onInputKeyDown($event)" autofocus />
						</dropdown-button-item>
						<dropdown-button-item *ngFor="let company of companies" class="px-4" (itemClick)="selectCompany(company.externalId)">
							{{ company.fiscalNumber }} - {{company.companyName}}
						</dropdown-button-item>
					</dropdown-button>
				</div>
			</div> -->
			
			<!-- languages section -->
			<div *ngIf="parent.showLanguages && !parent.isSubcontractor" class="header-group-action">
				<div class="d-flex h-100 align-items-center">
					<dropdown-button id="translationMenu" [hover]="true" 
						class="waves-effect waves-block waves-light header-languages" list-class="header-languages">
						<img src="/images/flag-icons/United-States.png" class="selected" alt="USA" />
						<dropdown-button-item>
							<img src="/images/flag-icons/United-States.png" alt="English" />
							<span class="language-select">English</span>
						</dropdown-button-item>
						<dropdown-button-item>
							<img src="/images/flag-icons/France.png" alt="French" />
							<span class="language-select">French</span>
						</dropdown-button-item>
						<dropdown-button-item>
							<img src="/images/flag-icons/Germany.png" alt="German" />
							<span class="language-select">German</span>
						</dropdown-button-item>
					</dropdown-button>
				</div>
			</div>

			<!-- user zone/role section -->
			<div #rolesAnchor *ngIf="parent.authService.isLoggedIn && (parent.authService.displayZones.length > 1 || parent.authService.selectedZoneCode != parent.PredefinedUserZone.Administrator)"
				class="header-group-action cursor-pointer"
				(mouseenter)="showRoles()" (mouseleave)="hideRoles()" (click)="toggleRoles()">
				<div class="user-role-container d-flex h-100 align-items-center px-3">
					<span class="user-role">{{ parent.authService.selectedZoneDisplayName }}</span>
					<i *ngIf="parent.authService.displayZones.length > 1" class="mdi-navigation-arrow-drop-down" style="display: inline; margin-top: -3px;"></i>
				</div>
				<kendo-popup *ngIf="isRolesVisible && parent.authService.displayZones.length > 1"
					[anchor]="{ nativeElement: rolesAnchor }"
					[popupAlign]="rolesPopupAlign"
					[anchorAlign]="rolesAnchorAlign"
					[animate]="false"
					(mouseenter)="cancelHideRoles()" (mouseleave)="hideRolesFromPopup()">
					<header-roles
						[selectedZoneDisplayName]="parent.authService.selectedZoneDisplayName"
						[zones]="displayZones"
						(zoneClick)="onZoneClick($event)">
					</header-roles>
				</kendo-popup>
			</div>
			
			<!-- profile section -->
			<div #userProfileAnchor *ngIf="parent.authService.isLoggedIn" class="header-group-action cursor-pointer"
				(mouseenter)="showUserProfile()" (mouseleave)="hideUserProfile()" (click)="toggleUserProfile()">
				<div class="d-flex h-100 align-items-center">
					<a class="waves-effect waves-block waves-light">
						<img class="header-avatar" src="{{ '/users/' + parent.authService.user.externalId + '/profile/picture/thumbnail' }}"
							alt="{{ parent.authService.userName }}" (error)="onAvatarError($event)"/>
					</a>
				</div>
				<kendo-popup *ngIf="isUserProfileVisible"
					[anchor]="{ nativeElement: userProfileAnchor }"
					[popupAlign]="userProfilePopupAlign"
					[anchorAlign]="userProfileAnchorAlign"
					[animate]="false"
					(mouseenter)="cancelHideUserProfile()" (mouseleave)="hideUserProfileFromPopup()">
					<header-profile
						[userName]="parent.authService.userName"
						[userEmail]="parent.authService.userEmail"
						[userNameInitialLetters]="parent.authService.userNameInitialLetters"
						(profileClick)="gotoProfile()"
						(helpClick)="gotoContact()"
						(logoutClick)="parent.authService.logout()">
					</header-profile>
				</kendo-popup>
			</div>

			<!-- actions section -->
			<!-- [removed] goToContact button -->
			<div *ngIf="false && !parent.isSubcontractor" class="header-group-action d-none d-sm-block">
				<div class="d-flex h-100 align-items-center">
					<a href="javascript:void(0);" (click)="parent.gotoContact()" class="waves-effect waves-block waves-light">
						<i class="mdi-action-help"></i>
					</a>
				</div>
			</div>

			<!-- help button -->
			<div #helpAnchor class="header-group-action d-none d-sm-block"
				(mouseenter)="showHelp()" (mouseleave)="hideHelp()" (click)="toggleHelp()">
				<div class="d-flex h-100 align-items-center">
					<!-- <a class="waves-effect waves-block waves-light" (click)="toggleHelp()"> -->
					<a class="waves-effect waves-block waves-light">
						<i class="mdi-help"></i>
					</a>
				</div>
				<kendo-popup *ngIf="isHelpVisible"
					[anchor]="{ nativeElement: helpAnchor }"
					[popupAlign]="helpPopupAlign"
					[anchorAlign]="helpAnchorAlign"
					[animate]="false"
					(mouseenter)="cancelHideHelp()" (mouseleave)="hideHelpFromPopup()">
					<header-help
						[helpId]="parent.helpId"
						[helpVideos]="parent.helpVideos"
						[helpMenuItems]="parent.helpMenuItems"
						[helpUserGuides]="parent.helpUserGuides"
						(openHelpMenuEditor)="openHelpMenuEditor()"
						(closeHelpMenuEditor)="closeHelpMenuEditor()"
						(openHelpVideoEditor)="openHelpVideoEditor()"
						(closeHelpVideoEditor)="closeHelpVideoEditor()">
					</header-help>
				</kendo-popup>
			</div>


			<!-- [removed] notification button -->
			<div *ngIf="false && parent.showSideBar && parent.authService.isLoggedIn && parent.notifications.length && !parent.isSubcontractor" class="header-group-action">
				<div class="d-flex h-100 align-items-center">
					<dropdown-button id="notificationMenu" [hover]="true"
						class="waves-effect waves-block waves-light header-notifications h-100" list-class="header-notifications"
						(click)="parent.gotoNotification()">
						<i class="mdi-social-notifications">
							<small class="notification-badge">{{parent.notifications.length}}</small>
						</i>
						<li list-top>
							<div class="h5">NOTIFICĂRI
								<span class="badge badge-secondary">{{parent.notifications.length}}</span>
							</div>
						</li>
						<li list-top class="divider"></li>
						<dropdown-button-item *ngFor="let notification of parent.notifications" (itemClick)="parent.gotoNotification(notification.externalId)">
							{{notification.subject}}
							<div class="w-100 px-0 text-right grey-text text-darken-4">
								<time list-item-bottom class="media-meta" [dateTime]="notification.created">{{notification.createdText}}</time>
							</div>
						</dropdown-button-item>
					</dropdown-button>
				</div>
			</div>

			<!-- [removed] fullScreen button -->
			<div *ngIf="false && !parent.isSubcontractor" class="header-group-action d-none d-sm-block">
				<div class="d-flex h-100 align-items-center">
					<a href="javascript:void(0);" (click)="parent.toggleFullScreen()" class="waves-effect waves-block waves-light toggle-fullscreen">
						<i class="mdi-action-settings-overscan"></i>
					</a>
				</div>
			</div>
		</div>
	</div>
</header>